import type { ReactNode } from 'react';

type TooltipContent = ReactNode;

type KeywordResearchTooltips = {
  columns: {
    URL: TooltipContent;
    Keyword: TooltipContent;
    rank_now: TooltipContent;
    difference: TooltipContent;
    len_keyword: TooltipContent;
  };
  competitors: {
    suggested_competitors: TooltipContent;
    changesCard: TooltipContent;
    bar_echart: TooltipContent;
    linear_echart: TooltipContent;
  };
  clustering: {
    helper: TooltipContent;
    kmeanRange: TooltipContent;
    clusterFromTask: TooltipContent;
    clusterFromTaskMinKeywords: TooltipContent;
    clusterFromTaskNotReady: TooltipContent;
  };
  massive: {
    source: TooltipContent;
    mode: TooltipContent;
    helper: TooltipContent;
    filterResults: TooltipContent;
    smartFilter: TooltipContent;
    include: TooltipContent;
    exclude: TooltipContent;
    clusterFromTask: TooltipContent;
    clusterFromTaskMinKeywords: TooltipContent;
    massive_details_columns: {
      keyword: TooltipContent;
      len: TooltipContent;
      source: TooltipContent;
      parent_keyword: TooltipContent;
      grand_parent_keyword: TooltipContent;
    };
  };
  gap: {
    keywordOverlap: TooltipContent;
  };
};

export const keywordResearchTooltips: KeywordResearchTooltips = {
  columns: {
    URL: 'نشانی یعنی آدرس صفحه‌ای که در نتایج گوگل وجود داره.',
    Keyword: 'کلماتی که سایت مذکور در نتایج گوگل دارای رتبه هست.',
    rank_now: (
      <p>
        میانگین رتبه در هفته‌های اخیر در این ستون قابل مشاهده هست. اگر سوالی
        درباره متفاوت بودن رتبه‌ها داشتید{' '}
        <a
          rel="noreferrer noopener"
          target="_blank"
          href="https://help.mizfa.tools/position-tracking-results-difference/ "
        >
          این مقاله{' '}
        </a>{' '}
        رو مطالعه کنید.
      </p>
    ),
    difference:
      'تغییرات رتبه نسبت به هفته‌های گذشته، به کمک این ستون متوجه میشید سایت رقیب در کلمه مد نظر شما رشدی داشته یا نه.',
    len_keyword: 'به تعداد کلماتی که در کلمه کلیدی وجود داره گفته میشه.'
  },
  competitors: {
    suggested_competitors:
      'براساس الگوریتم‌های میزفا تولز به شما یک سری رقبای پیشنهادی ارائه میشه، اگر رقیب مد نظر شما در این فهرست نیست، می‌تونید به راحتی در باکس جستجوی بالا، دامنه رقیب خود رو وارد کنید.',
    changesCard:
      'این بخش به شما کمک میکنه تا متوجه بشید سایت مذکور چه تغییراتی در دو بازه زمانی در تعداد کلمات TOP داشته. در این بخش مقایسه کلمات TOP یا کلمات بالا بین دو تاریخ صورت میگیره، که به صورت پیش‌فرض یکی از تاریخ‌ها آخرین تاریخ (تاریخی که نزدیک به امروزه) هست و تاریخ دوم برای مقایسه قابل انتخاب هست که اصولا اولین تاریخی که میزفا تولز در این سایت اطلاعات داره رو نمایش میده.',
    bar_echart:
      'این بخش به شما کمک میکنه تا متوجه بشید سایت مذکور چه تغییراتی در کل بازه زمانی در تعداد کلمات TOP داشته. در این بخش مقایسه کلمات TOP یا کلمات بالا در کل بازه صورت گرفته، اگر به عنوان مثال، رشد TOP1 برابر با ۵ باشه، این به معنای افزایش پنج برابری تعداد کلمات TOP1 در طول زمان هست.',
    linear_echart:
      'این بخش به شما کمک میکنه تا متوجه بشید سایت مذکور چه تغییراتی در کل بازه زمانی در تعداد کلمات TOP داشته. در این بخش روند کلمات TOP یا کلمات بالا در کل بازه رو نمایش میده.'
  },
  clustering: {
    helper:
      'خوشه بندی کلمات (Keyword Clusters) به شما کمک میکنه تا کلماتی که دارید رو گروه‌بندی کنید، مخصوصا وقتی تعداد کلمات بالا دارید، بسیار زمان‌بر هست که کلمات مشابه رو چشمی بررسی کنید و گروه‌بندی کنید. مثلا شما می‌تونید هزاران کلمه کلیدی که از طریق سرچ کنسول یا از طریق کلمات انبوه میزفا تولز پیدا می‌کنید رو در این بخش گروه‌بندی کنید.',
    kmeanRange:
      'مقدار 90 درصد یک مقدار ایده‌آل هست، با این حال اگر این مقدار رو افزایش بدید تعداد تقسیم‌بندی کلمات بیشتر میشه و اگر کمتر کنید تقسیم‌بندی کمتر میشه.',
    clusterFromTask: (
      <p className="text-start">
        کلمات همین گزارش رو برای خوشه‌بندی ارسال می‌کنه تا گروه‌های موضوعی مشابه
        شناسایی بشن. بعد از ثبت درخواست، به صفحه خوشه‌بندی منتقل می‌شید.
      </p>
    ),
    clusterFromTaskMinKeywords:
      'برای خوشه‌بندی باید حداقل ۵۰ کلمه داشته باشید.',
    clusterFromTaskNotReady:
      'برای خوشه‌بندی باید صبر کنید تا دریافت اطلاعات تمام شود.'
  },
  massive: {
    source:
      'از چه منبعی برای پیدا کردن کلمات استفاده کنه؟ به ترتیب منابع قابل انتخاب به این صورت هست: گوگل، یوتیوب، بینگ و میزفاتولز',
    mode: (
      <p className="text-start">
        <strong>تودرتو:</strong> یعنی کلمه‌ای که وارد کردی رو از طریق منبع میره
        سرچ میکنه و کلمات پیشنهادی اون رو پیدا میکنه و سپس همین کار رو برای
        کلمات پیشنهادی انجام میده و این روند همینطوری ادامه پیدا میکنه.
        <br />
        <br />
        <strong>سوالی:</strong> یعنی کلمه‌ای که وارد کردی رو براساس یک سری حروف
        سوالی در منبع سرچ میکنه و کلمات پیشنهادی رو به شما نمایش میده.
      </p>
    ),
    helper: (
      <p className="text-start">
        حداقل ۱ کلمه کلیدی باید وارد کنی، اگر کلمه کلیدی پیدا نشد این معنا رو
        داره که کلمه درج شده جستجوی زیادی نداره، به همین منظور بهتره کلمه
        دیگه‌ای رو انتخاب کنی.
        <br />
        برای گرفتن نتیجه بهتر یک کلمه کلی وارد کنید تا ابزار به شما کلمات طولانی
        پرسرچ اخیر رو نمایش بده.
      </p>
    ),
    filterResults: (
      <p className="text-start">
        با فیلتر شخصی می‌تونید خروجی کلمات انبوه رو محدود کنید تا فقط کلمات
        مرتبط‌تر باقی بمونن.
        <br />
        <br />
        مثلاً می‌تونید عبارت‌هایی مثل «دیجیکالا» یا «نی‌نی‌سایت» که زیاد تکرار
        می‌شن و معمولاً به موضوع اصلی شما مربوط نیستن رو فیلتر کنید تا نتایج
        تمیزتر و کاربردی‌تری داشته باشید.
      </p>
    ),
    smartFilter: (
      <p className="text-start">
        با کمک AI، کلمات نامرتبط و کم‌ارزش به‌صورت خودکار از نتایج حذف می‌شن تا
        خروجی تمیزتر و کاربردی‌تر باشه.
      </p>
    ),
    include: (
      <p className="text-start">
        فقط کلماتی در نتایج نگه داشته می‌شن که شامل عبارت‌های واردشده باشن.
        <br />
        هر عبارت رو در یک خط بنویسید. با انتخاب «یا» کافی‌ست یکی از عبارت‌ها
        داخل کلمه باشه و با انتخاب «و» باید همه عبارت‌ها داخل کلمه باشن.
      </p>
    ),
    exclude: (
      <p className="text-start">
        کلماتی که شامل عبارت‌های واردشده باشن از نتایج حذف می‌شن.
        <br />
        مثلاً اگر «دیجیکالا» یا «نی‌نی‌سایت» رو وارد کنید، هر کلمه‌ای که این
        عبارت‌ها رو داشته باشه از خروجی حذف می‌شه. هر عبارت رو در یک خط بنویسید.
      </p>
    ),
    clusterFromTask: (
      <p className="text-start">
        کلمات همین گزارش انبوه رو برای خوشه‌بندی ارسال می‌کنه تا گروه‌های موضوعی
        مشابه شناسایی بشن. بعد از ثبت درخواست، به صفحه خوشه‌بندی منتقل می‌شید.
      </p>
    ),
    clusterFromTaskMinKeywords:
      'برای خوشه‌بندی باید حداقل ۵۰ کلمه داشته باشید.',
    massive_details_columns: {
      keyword:
        'کلماتی که براساس کلمات والد به دست میاد. برای استفاده در پروژه ها پیشنهاد میشه به ستون کلمه و کلمه والد دقت بیشتری داشته باشید.',
      len: 'تعداد کلمات ستون کلمه',
      source:
        'نام منبعی که شما انتخاب کردید و براساس منبع کلمه ریشه، کلمه والد و ستون کلمه رو پیدا میکنه.',
      parent_keyword: 'کلمه والد براساس کلمات ریشه به دست میاد.',
      grand_parent_keyword:
        'کلمه ریشه براساس کلمات وارد شده توسط شما در کلمات انبوه به دست میاد.'
    }
  },
  gap: {
    keywordOverlap:
      'نمودار همپوشانی کلمات به شما کمک می‌کنه تا میزان اشتراک کلمات بین چند دامنه رو بررسی کنید. این نمودار نشان میده که کدام کلمات بین شما و رقبا مشترک هستن و چه میزان از آن‌ها منحصراً در هر دامنه دیده میشه. به صورت کلی این نمودار کمک میکنه تا بتونید فرصت‌های بهینه‌سازی رو شناسایی کنید و مقایسه میزان تسلط بر کلمات رو بسنجید همینطور به تحلیل نقاط قوت و ضعف رقبا کمک زیادی میکنه و در نهایت شما میتونید یک برنامه‌ریزی برای استراتژی محتوا داشته باشید.'
  }
};
